import React from 'react';
import { Box, Grid } from '@chakra-ui/react';

const ChartGrid: React.FC = () => {
  return (
    <Box
      position="absolute"
      width="100%"
      height="100%"
      top={0}
      left={0}
    >
      {/* Horizontal lines */}
      {[0, 25, 50, 75, 100].map((value) => (
        <Box
          key={`h-${value}`}
          position="absolute"
          left={0}
          width="100%"
          height="1px"
          top={`${100 - value}%`}
          bg="gray.200"
        />
      ))}

      {/* Vertical lines */}
      {[0, 25, 50, 75, 100].map((value) => (
        <Box
          key={`v-${value}`}
          position="absolute"
          top={0}
          height="100%"
          width="1px"
          left={`${value}%`}
          bg="gray.200"
        />
      ))}
    </Box>
  );
};

export default ChartGrid; 